var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoDefault = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u4FE1\u606F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4FE1\\u606F"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fillOpacity: 0.4,
    fill: "#52C41A",
    cx: 9,
    cy: 5,
    r: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u4FE1\\u606F-(1)",
    fill: "#041B0F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.96333269,5.49894414 L4.9641006,5.49894414 C4.68727204,5.49894414 4.46419658,5.27586869 4.46419658,4.99904012 C4.46419658,4.72221154 4.68727202,4.4991361 4.9641006,4.4991361 L8.96333269,4.4991361 C9.24016125,4.4991361 9.46323671,4.72221156 9.46323671,4.99904013 C9.46323671,5.27586871 9.24016127,5.49894414 8.96333269,5.49894414 Z",
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01459013,7.4985602 L4.9641006,7.4985602 C4.68727204,7.4985602 4.46419658,7.27548476 4.46419658,6.99865618 C4.46419658,6.7218276 4.68995968,6.49875216 4.9641006,6.49875216 L8.01459013,6.49875216 C8.29141869,6.49875216 8.51449415,6.7218276 8.51449415,6.99865618 C8.51449415,7.27548476 8.29141871,7.4985602 8.01459013,7.4985602 Z",
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,5.99884816 C14,2.69034364 10.8608178,0 7.00134382,0 C3.14186982,0 0,2.69034364 0,5.99884816 C0,7.81839126 0.983682082,9.53042811 2.70109426,10.6968708 C2.92954501,10.8527549 3.24131311,10.7936264 3.39450951,10.5651757 C3.55039355,10.3367249 3.49126513,10.0249568 3.26281438,9.87176042 C1.82491843,8.8961413 0.999808039,7.48512191 0.999808039,6.00153581 C0.999808039,3.24400078 3.69015168,1.00249568 6.9986562,1.00249568 C10.3071607,1.00249568 12.9975044,3.24668842 12.9975044,6.00153581 C12.9975044,8.7563832 10.3071607,11.0005759 6.9986562,11.0005759 C6.96640433,11.0005759 6.94221543,11.0113266 6.9126512,11.0193895 C6.67613747,10.976387 6.43693608,11.1000192 6.35361875,11.3338453 C6.25686314,11.6052985 5.62795164,12.0622001 4.88347094,12.4868497 C5.15492419,11.578422 5.02591671,11.3822231 4.93722405,11.2532156 C4.83240548,11.0973316 4.65770784,11.0032636 4.46957192,11.0032636 C4.19274336,11.0032636 3.9696679,11.226339 3.9696679,11.5031676 C3.9696679,11.5945479 3.9938568,11.6778653 4.0368593,11.7531196 C3.98579384,12.0380112 3.7680937,12.7045498 3.52082936,13.3119601 C3.44288734,13.500096 3.48857749,13.7177961 3.63639857,13.8602419 C3.73046653,13.9516222 3.85678636,14 3.98310618,14 C4.05029759,14 4.12017665,13.9865617 4.18736803,13.9569975 C4.75715109,13.7016702 6.49337687,12.8765598 7.11960072,11.9950087 C10.9226339,11.9385679 14,9.2751008 14,5.99884816 Z",
    id: "\\u8DEF\\u5F84"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info_default.717a61937aaa8cebf511f3010cad807e.svg";